/** @jsx jsx */
import { jsx } from 'theme-ui'
import { Box } from 'rebass'

const Overlay = (props) => {
    return (
        <Box {...props}
            bg={props.bg}
            opacity={props.opacity}
            sx={{
                position: 'absolute',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                width: '100%',
                height: '100%',
                zIndex: 1,
            }}
        >
            {props.children}
        </Box >
    )
}

Overlay.defaultProps = {
    bg: 'black',
    opacity: '0.5',
}

Overlay.displayName = 'Overlay'

export default Overlay
